import { useAppTextsStore } from '~/stores/appTexts'

export function useServerText(id: string, fallback?: string) {
	const store = useAppTextsStore()

	return computed(() => {
		if (!store.texts) return fallback
		return store.texts[id] || fallback
	})
}
